import { Translation } from './Translation';

export const fr_FR: Translation = {
  translation: {
    placeholders: {
      notApplicable: 'Non applicable',
      placeholder: 'Marque substitutive',
      dropdownDefault: 'Sélectionner',
      typeToFilter: 'Filtrer par type',
      typeToSearch: 'Tapez pour rechercher',
      textareaDefault: 'Saisir ici',
    },
    errors: {
      textLimit:
        'Vous avez dépassé le nombre de caractères. Veuillez réduire le nombre de caractères afin de poursuivre votre briefing.',
    },
    labels: {
      eLab: 'Azelis e-Lab',
      additionalInfo:
        'Notes (p. ex. Référence, date limite, autres pays cibles,...)',
      price: 'p. ex. 2,88 – 3,33 {{currency}}/{{weightUnit}}',
      targetPackaging: 'Emballage cible',
      notes: 'Notes',
      attachments: 'Pièces jointes',
      enterAName: 'Saisir un nom',
      addAttachment: 'Ajouter une pièce jointe',
      optional: 'Facultatif',
      loading: 'Chargement',
      briefing: {
        sent: 'Briefing envoyé',
        delivered: 'Briefing remis',
      },
      signIn: 'Se connecter',
      signOut: 'Se déconnecter',
      requestAccess: 'Demander l’accès',
      multiSelectHint: 'Plusieurs sélections possibles',
      other: 'Autre',
      noOptions: 'Aucune option',
      or: 'ou',
      createdAt: 'Créé à',
      createdBy: 'Créé par',
      status: 'Statut',
      continue: 'Continuer',
      untitled: 'Sans titre',
      countries: {
        Benelux: 'Benelux',
        Belgium: 'Belgique',
        France: 'France',
        Germany: 'Allemagne',
        India: 'Inde',
        Indonesia: 'Indonésie',
        Italy: 'Italie',
        Ireland: 'Irlande',
        Luxembourg: 'Luxembourg',
        Netherlands: 'Pays-Bas',
        'United Kingdom': 'Royaume-Uni',
      },
      languages: {
        de_DE: 'Allemand',
        en_GB: 'Anglais',
        en_US: 'Anglais',
        fr_FR: 'Français',
        zh_CN: 'Chinois',
        ko_KR: 'Coréen',
      },
      countrySlug: {
        BNL: 'Benelux',
        FR: 'France',
        GB: 'Royaume-Uni',
        UK: 'Royaume-Uni',
        DE: 'Allemagne',
        IN: 'Inde',
        IT: 'Italie',
        ID: 'Indonésie',
        IE: 'Irlande',
      },
      markets: {
        AgriEnvironmental: 'Agricultural & Environmental Solutions',
        SpecialtyAgriHorti: 'Special Agricultural & Environmental Solutions',
        FoodNutrition: 'Food & Nutrition',
        FoodHealth: 'Food & Health',
        HomeCareIndustrialCleaning: 'Home Care & Industrial Cleaning',
        HomecareIndustrialCleaning: 'Home Care & Industrial Cleaning',
        PersonalCare: 'Personal Care',
      },
      ofTotal: 'sur {{total}}',
      perPage: 'Par Page',
      briefingFlowTag: {
        base: 'base',
        colour: 'colour',
        fragrance: 'fragrance',
        formulation: 'formulation',
      },
    },
    linksOrButtons: {
      details: 'Détails',
      backTo: 'Retour aux',
      seeProjectOverview: 'Voir l’aperçu du projet',
      backToOverview: 'Retour à l’aperçu',
      backToReview: 'Aller à la revue',
      showMore: 'Afficher plus',
      goToInspiration: 'Inspirez-vous ici',
      startNewFormulation: 'Commencer une nouvelle formulation',
      toggleMenu: 'Menu déroulant',
      navigation: {
        start: 'Commencer la formulation',
        'project-overview': 'Mes formulations',
      },
      backToStart: 'Menu',
      edit: 'Modifier',
      next: 'Suivant',
      prev: 'Préc',
      sendBriefing: 'Envoi du projet',
    },
    topics: {
      application: {
        name: 'Applications',
        heading: {
          create:
            'Quelle est l’application / l’utilisation finale du produit ?',
          fix: 'Quelle est l’application de la formulation que vous souhaitez corriger ?',
          enhance:
            'Quel type d’application possède la formulation que vous souhaitez améliorer ?',
          modify: 'What is the product application and end use?',
        },
        levels: {
          '0': {
            normal: 'Catégorie principale',
            selected: 'Catégorie principale',
            other: 'Spécifier votre sélection',
            otherPlaceholder: 'Nouveau nom de catégorie principale',
            product: 'Product Category',
          },
          '1': {
            normal: 'Choisir une sous-catégorie',
            selected: 'Sous-catégorie',
            other: 'Spécifier votre sélection',
            otherPlaceholder: 'Nouveau nom de sous-catégorie',
            technology: 'Technology',
          },
          '2': {
            normal: 'Choisir une ou plusieurs caractéristiques',
            selected: 'Caractéristique',
            other: 'Spécifier votre caractéristique',
            otherPlaceholder: 'Nouveau nom de caractéristique',
            endUse: 'Utilisation finale',
            specifyEndUse: 'Specify your end use',
            endUsePlaceholder: 'End use name',
          },
        },
      },
      'formulation-attributes': {
        name: 'Marketing',
        heading: {
          general:
            'Quelles sont vos contraintes connues en terme de marketing, conservation?',
        },
        productMarketingClaims: 'Arguments de vente du produit',
        formulationType: 'Type de formulation',
        texture: 'Texture',
        storage: 'Conservation',
        productForm: 'Product Form',
        otherProductMarketingClaims:
          'Spécifier d’autres arguments de vente du produit',
        otherFormulationType: 'Spécifier un autre type de formulation',
        otherTexture: 'Spécifier une autre texture',
        otherStorage: 'Spécifier autre stockage',
        options: {
          availableProductMarketingClaims: {
            euEcolabel: 'EU Ecolabel',
            rspoCertified: 'RSPO Certified',
            bioBasedProduct: 'Bio-based product / natural derived',
            nordicSwan: 'Nordic Swan',
            euEcocert: 'EU Ecocert',
            lowCLP: 'Low CLP (classification)',
            lowToZeroVOC: 'Low to Zero VOC',
            biodegradable: '(Readily) biodegradable',
            lowAllergens: 'Low Allergens',
            highActive: 'High Active',
            nonLabelledForCLP: 'Non-Labelled for CLP',
            mildToSkinAndEyes: 'Mild to skin and eyes',
            easyToHandle: 'Easy to handle',
            highlyEffectiveLowDosageLevels:
              'Highly effective / low dosage levels',
            preservativeFree: 'Preservative free',
            foodContact: 'Food contact',
            noAnimalTesting: 'No animal testing',
            nanoparticlesFree: 'Nanoparticles free',
            lowSVHC: 'Low SVHC',
            natural: 'Natural',
            vegan: 'Vegan',
            noHeavyMetals: 'No heavy Metals',
            soothing: 'apaisant',
            moisturising: 'hydratant',
            sensitiveSkin: 'peau sensible',
            woundProtection: 'protection des plaies',
            calming: 'calmant',
            waterSaving: 'permettant d’économiser l’eau',
            antiageing: 'anti-âge',
            softFocus: 'soft focus',
            wrinkleFilling: 'comblement des rides',
            antiCreasing: 'défroissant',
            longLasting: 'longue durée',
            easyToApply: 'facile à appliquer',
            quickDrying: 'séchage rapide',
            waterProof: 'résistant à l’eau',
            highCoverage: 'haute couvrance',
            hydrating: 'hydratant',
            oilAbsorbing: 'absorbant l’huile',
            nonBleedingFeathering: 'ne déteint pas/anti-effilage',
            glossy: 'brillant',
            kissProof: 'à l’épreuve des baisers',
            rubResistant: 'résistant aux frottements',
            removesWaterproof: 'élimine l’imperméabilité à l’eau',
            gentle: 'doux',
            wearResistant: 'bonne tenue',
            easyToRemove: 'facile à retirer',
            highGlossShine: 'plein d’éclat/brillant',
            dermatologicallyTested: 'testé dermatologiquement',
            antibacterial: 'antibactérien',
            forSensitiveSkin: 'pour peau sensible',
            softening: 'adoucissant',
            detangling: 'démêlant',
            dryDamaged: 'secs/abîmés',
            fineHair: 'cheveux fins',
            colourProtection: 'protection de la couleur',
            colourEnhancing: 'renforcement de la couleur',
            antiDandruff: 'anti pellicules',
            conditioning: 'après-shampooing',
            sulphateFree: 'sans sulfate',
            antiBuildUp: 'anti-accumulation',
            twoInOne: '2 en 1',
            permanent: 'permanente',
            semiPermanent: 'semi-permanente',
            rootTouchUp: 'retouche racines',
            temporary: 'temporaire',
            treatment: 'traitement',
            hairStrengthening: 'renforcement des cheveux',
            revitalising: 'revitalisant',
            exfoliating: 'exfoliant',
            strengthening: 'renforcement',
            damageRepair: 'réparateur',
            thickening: 'épaississant',
            protection: 'protection',
            protecting: 'protecteur',
            strongHold: 'à forte tenue',
            improvedComfort: 'confort amélioré',
            foodseal: 'antiparticules',
            gumCare: 'soin des gencives',
            whitening: 'blancheur',
            alcoholFree: 'sans alcool',
            enamelCare: 'soin émail',
            sensitive: 'sensible',
            antiseptic: 'antiseptique',
            antiBacterial: 'antibactérien',
            antiAgeing: 'anti-âge',
            antioxidant: 'antioxydant',
            antiPollution: 'anti-pollution',
            repair: 'réparateur',
            skinTightening: 'renforcement de la peau',
            illuminatingBrightning: 'éclatant/lumineux',
            antiPuffinessDark: 'anticernes/contour des yeux',
            cycles: 'cycles',
            purifying: 'purifiant',
            oilControl: 'matifiant',
            cooling: 'rafraîchissant',
            extraFirmHold: 'tenue extra ferme',
            firmHold: 'tenue ferme',
            lightHold: 'tenue légère',
            curlDefining: 'définissant les boucles',
            volumising: 'volumisant',
            mediumHold: 'tenue moyenne',
            flexibleHold: 'tenue flexible',
            shine: 'brillance',
            weatherproof: 'résistant aux intempéries',
            uvProtection: 'protection contre les UV',
            waterResistant: 'résistant à l’eau',
            floral: 'floral',
            fougère: 'fougère',
            aromatic: 'aromatique',
            woody: 'boisé',
            citrus: 'agrumes',
            amber: 'ambré',
            chypre: 'chypré',
            fruity: 'fruité',
            gourmand: 'gourmand',
            musk: 'musc',
            spicy: 'épicé',
            cleanLabel: 'Clean label',
            naturalColours: 'Colorants naturels',
            naturalFlavours: 'Arômes naturels',
            glutenFree: 'Sans gluten',
            allergenFree: 'Sans allergène',
            palmFree: 'Sans huile de palme',
            nanoFree: 'Sans nanoparticules',
            noReducedFat: 'Sans / à faible teneur en matière grasse',
            noReducedSugar: 'Sans / à faible teneur en sucre',
            noReducedSalt: 'Sans / à faible teneur en sel',
            sourceHighFiber: 'Source de / Riche en fibres',
            sourceHighProtein: 'Source de / Riche en protéines',
            sourceHighVitaminsMinerals:
              'Source de / Riche en vitamines et minéraux',
            healthBenefices: 'Bénéfique pour la santé',
            veganVegetarianAnimalFree:
              'Végan / Végétarien / Sans matière animale',
            organic: 'Bio',
            fairTrade: 'Commerce équitable',
            halal: 'Halal',
            kosher: 'Casher',
            sweatReduction: 'Réduction de la transpiration',
            odourProtection: 'Protection anti-odeurs',
            aluminiumFree: 'Sans aluminium',
            noWhitening: 'Pas de traces blanches',
            invisible: 'Invisible',
            refreshing: 'Rafraîchissant',
            moisturizing: 'Hydratant',
          },
          availableFormulationTypes: {
            owEmulsion: 'Émulsion H/E',
            woEmulsion: 'Émulsion E/H',
            waterBased: 'À base d’eau',
            oilBased: 'À base d’huile',
            emulsion: 'émulsion',
            anhydrous: 'anhydre',
            alcoholic: 'alcoolisé',
            nonAlcoholic: 'non alcoolisé',
            other: 'Autre',
            solidStick: 'Stick solide',
            gelStick: 'Stick gel',
            aerosolSpray: 'Spray aérosol',
            nonAerosolSpray: 'Spray non aérosol',
            cream: 'Crème',
            rollOn: 'Roll On',
            powder: 'Poudre',
          },
          availableTextures: {
            fluid: 'Liquide',
            spray: 'Pulvérisateur',
            serum: 'Sérum',
            aerosol: 'Aérosol',
            gel: 'Gel',
            lotion: 'Lotion',
            cream: 'Crème',
            solid: 'Solide',
            foam: 'Mousse',
            powder: 'Poudre',
            liquid: 'Liquide',
            tablet: 'Comprimé',
            stick: 'Stick',
            bar: 'Barre',
            nonAerosol: 'Non aérosol',
            other: 'Autre',
            soft: 'Douce',
            emulsion: 'Emulsion',
          },
          availableStorage: {
            ambient: 'Ambiant',
            bakeryDryBlend: 'Mélange poudre',
            instantDryBlend: 'Instantané (mélange poudre)',
            frozen: 'Surgelé',
            bestBefore: 'Longue DLC',
            pasteurisation: 'Pasteurisation',
            chilled: 'Réfrigéré',
            bakeStability: 'Stabilité de cuisson (micro-ondes)',
          },
          availableProductForm: {
            powder: 'Powder',
            liquid: 'Liquid',
            granules: 'Granules',
            flakes: 'Flakes',
            paste: 'Paste',
            wax: 'Wax',
            prills: 'Prills',
            needles: 'Needles',
            piece: 'Piece',
            emulsion: 'Emulsion',
          },
        },
        errors: {
          productMarketingClaims: 'Erreur de chargement des arguments de vente',
        },
      },
      fragrance: {
        name: 'Fragrance',
        heading: {
          general: 'Fragrance your formulation',
        },
        fragranceFormulation:
          'Do you want to have your formulation fragranced?',
        attributesFulfill: 'Which attributes should your fragrance fulfill?',
        requirements:
          'Are there any requirements that the fragrance needs to comply to?',
        colourOrConcept: 'Concept / Colour',
        CMR: 'CMR (Carcinogenic, mutagenic and reprotoxic)',
        direction: 'Fragrance direction',
        mustComply: 'Fragrance must comply to',
        maxAllergensOnLabel: 'Max amount allergens on label',
        requestedApplicationDosage: 'Requested application dosage (in %)',
        fragranceSamples: 'Is there a need for fragrance samples?',
        requiredSampleTime: {
          heading: 'What is the required timing you need the sample by?',
          label: 'Required sample time',
        },
        largerFragranceSize: {
          heading:
            'Please specify if you need a larger fragrance sample size than 10gr per sample.',
          label: 'Larger sample size',
        },
        specifyFragranceMustOther: 'Specify other',
        options: {
          confirmFragranceOptions: {
            yes: 'Yes',
            no: 'No',
          },
          availableColoursOrConcepts: {
            black: 'Black',
            silver: 'Silver',
            white: 'White',
            blue: 'Blue',
            yellow: 'Yellow',
            pink: 'Pink',
            purple: 'Purple',
            green: 'Green',
            orange: 'Orange',
            gold: 'Gold',
            natural: 'Natural',
            clean: 'Clean',
            care: 'Care',
            hygiene: 'Hygiene',
            malodour: 'Malodour',
            performance: 'Performance',
            premium: 'Premium',
          },
          availableDirection: {
            citrus: 'Citrus',
            chypre: 'Chypre',
            floral: 'Floral',
            floriental: 'Floriental',
            fruity: 'Fruity',
            gourmand: 'Gourmand',
            green: 'Green',
            herbal: 'Herbal',
            lavender: 'Lavender',
            musk: 'Musk',
            oriental: 'Oriental',
            pine: 'Pine',
            spicy: 'Spicy',
            woody: 'Woody',
          },
          availableCMR: {
            notAllowed: 'Not allowed',
            allowedButOilNotLabelled: 'Allowed but oil not labelled CMR',
            allowed: 'Allowed',
          },
          mustComply: {
            noAllergensOnOil: 'No allergens on oil',
            noAllergensOnFinalProduct: 'No allergens on final product',
            pCMNMFree: 'PCM/NM free',
            ecoLabel: 'Ecolabel',
            okotestCandidate: 'Okotest candidate',
            vegan: 'Vegan',
            other: 'Other',
          },
        },
      },
      'processing-capabilities': {
        name: 'Process',
        heading: {
          general: 'Quelles sont les étapes de process de votre produit?',
        },
        bakeStability: 'Stabilité à la cuisson',
        bakingTime: 'Temps de cuisson (minutes)',
        bakingTemperature: 'Température de cuisson (°C)',
        fillingTime: 'Temps de remplissage (minutes)',
        fillingTemperature: 'Température de remplissage (°C)',
        mixingStepDetails:
          'Détails des étapes de mélange (mélangeur à haut cisaillement / à pales)',
        productPh: 'pH du produit',
        brix: 'Brix',
        processingCapabilitiesPackagingDetails: 'Type et détails d’emballage',
        foodSafetyDetails: 'Traitement thermique (Pasteurisation/UHT)',
        processingHotCold: 'Remplissage à froid/chaud',
        homogenisation: 'Homogénéisation',
        otherProcessingCapabilities: 'Autres informations de process',
      },
      restrictions: {
        name: 'Restrictions',
        heading: {
          general:
            'Y a-t-il des restrictions auxquelles la formulation doit se conformer ?',
        },
        requirements: 'Exigences',
        restrictions: 'Restrictions',
        can: 'Peut',
        must: 'Doit',
        mustComply: 'La formulation doit être conforme à',
        canComply: 'La formulation peut être conforme à',
        requirementsMust: 'Exigences - Doit',
        requirementsCan: 'Exigences - Peut',
        restrictionsMust: 'Restrictions - Doit',
        restrictionsCan: 'Restrictions - Peut',
        specifyRequirements: 'Spécifier les exigences',
        specifyRestrictions: 'Spécifier les restrictions',
        options: {
          silictions: 'sans silicones',
          parabens: 'sans parabènes',
          oil: 'pas d’ingrédients à base d’huile minérale',
          emulsifier: 'sans émulsifiant',
          preservatives: 'sans conservateurs',
          ethanol: 'sans éthanol',
          cold: 'production à froid',
          polymore: 'sans polymères synthétiques',
          uv: 'sans filtres UV organiques',
          nanomaterial: 'sans nanoparticules',
          sulfate: 'sans sulfate',
          surfactant: 'faible teneur en tensioactif',
          tears: 'formulation sans déchirures',
          talc: 'sans talc',
          notApplicable: 'Non applicable',
          other: 'Autre',
        },
        errors: {
          restrictions: 'Erreur de chargement des restrictions',
        },
      },
      requirements: {
        name: 'Requirements',
        heading: {
          general:
            'Are there any requirements that the formulation needs to comply to?',
          specify: 'Please specify your further formulation requirements',
        },
        requirements: 'Requirements',
        can: 'Can',
        must: 'Must',
        mustComply: 'Formulation must comply to',
        canComply: 'Formulation can comply to',
        requirementsMust: 'Requirements - Must',
        requirementsCan: 'Requirements - Can',
        specifyRequirements: 'Specify requirements',
        applicationConditionDetails: {
          heading:
            'Please indicate details on the application conditions (Type of surface or soil, temperature range …).',
          label: 'Application condition details',
        },
        pHRange: {
          heading: 'In which pH range the product needs to be active?',
          label: 'phRange',
        },
        aggressiveComponents: {
          heading:
            'Please list the potential aggressive components in the formulation.',
          label: 'Aggressive components',
        },
        lightStability: {
          heading: 'Is light stability important?',
          label: 'Light stability',
          answer: {
            yes: 'Yes',
            no: 'No',
          },
        },
        options: {
          biodegradable: '(Readily) biodegradable',
          bioBased: 'Bio-based product / natural derived',
          carBody: 'Car body shop compliant',
          coldPress: 'Cold process',
          easyToHandle: 'Easy to handle',
          euEcocert: 'EU Ecocert',
          euEcolabel: 'EU Ecolabel',
          foodContact: 'Food contact',
          halal: 'Halal',
          highActive: 'High active',
          highlyEffectiveLowDosageLevels:
            'Highly effective / low dosage levels',
          kosher: 'Kosher',
          lowAllergens: 'Low Allergens',
          lowCLP: 'Low CLP (classification)',
          lowSVHC: 'Low SVHC',
          lowToZeroVOC: 'Low to Zero VOC',
          mildToSkinAndEyes: 'Mild to skin and eyes',
          nanoparticlesFree: 'Nanoparticles free',
          natural: 'Natural',
          noAnimalTesting: 'No animal testing',
          noHeavyMetals: 'No heavy metals',
          nonLabelledForCLP: 'Non-Labelled for CLP',
          nordicSwan: 'Nordic Swan',
          palmFree: 'Palm free',
          phosphorFree: 'Phosphor free',
          preservativeFree: 'Preservative free',
          rspoCertified: 'RSPO Certified',
          vegan: 'Vegan',
          notApplicable: 'Not applicable',
          other: 'Other',
        },
        errors: {
          requirements: 'Error loading requirements',
        },
      },
      colour: {
        name: 'Colour',
        heading: {
          general: 'Colour your formulation',
        },
        formulationColoured: 'Do you want to have your formulation coloured?',
        colourAttributes: 'Which attributes should your colourant fulfill?',
        colourShades: 'Colour Shades',
        colourSamples: {
          label: 'Colour samples',
          heading: 'Is there a need for colour samples?',
        },
        requiredTime: {
          heading: 'What is the required timing you need the sample by?',
          label: 'Required sample time',
        },
        labSupport: {
          heading: 'Do you require support from the Miliken lab? ',
          label: 'Support from the supplier lab required?',
        },
        options: {
          confirmColourOptions: {
            yes: 'Yes',
            no: 'No',
          },
          shades: {
            cyanBlue: 'Cyan Blue',
            royalBlue: 'Royal Blue',
            darkBlue: 'Dark Blue',
            brightBlue: 'Bright Blue',
            aquamarineBlue: 'Aquamarine Blue',
            brightGreen: 'Bright Green',
            green: 'Green',
            brightYellow: 'Bright Yellow',
            lemonYellow: 'Lemon Yellow',
            darkYellow: 'Dark Yellow',
            yellow: 'Yellow',
            orange: 'Orange',
            fluorescentYellow: 'Fluorescent Yellow',
            brightViolet: 'Bright Violet',
            purple: 'Purple',
            darkViolet: 'Dark Violet',
            darkRed: 'Dark red',
            fluorescentPink: 'Fluorescent Pink',
            brightPink: 'Bright Pink',
            softPink: 'Soft Pink',
          },
        },
      },
      'target-consumer': {
        name: 'Consommateur cible',
        heading: {
          general: 'Qui est votre consommateur cible ?',
        },
        age: 'Age',
        targetConsumerAge: 'Age du consommateur cible',
        gender: 'Sexe',
        targetConsumerGender: 'Sexe du consommateur cible',
        buttons: {
          genders: {
            female: 'Femme',
            male: 'Homme',
            allGenders: 'Tous les sexes',
          },
          allAges: 'Tous les âges',
        },
      },
      'additional-info': {
        name: 'Infos supplémentaires',
        heading: {
          general: 'Avez-vous quelque chose à ajouter ?',
        },
        additionalInfo: 'Informations supplémentaires',
        additionalInfoFiles: 'Fichiers d’informations supplémentaires',
      },
      price: {
        name: 'Prix',
        heading: {
          general: 'Quel coût avez-vous estimé pour la formule ?',
          base: 'Quel coût avez-vous estimé pour la formulation de base ?',
          color: 'Quel coût avez-vous estimé pour la couleur ?',
          fragrance: 'Quel coût avez-vous estimé pour la parfum ?',
        },
      },
      'product-details': {
        name: 'Product Details',
        heading: {
          general: 'Please specify your product details.',
        },
        finishedProductSamples: {
          heading: 'Is there a need for samples of the finished product?',
          answer: {
            yes: 'Yes',
            no: 'No',
          },
          requiredTimeForSample: 'What is the required time for the sample?',
        },
        finishedProductPotential:
          'What is the finished product potential? (t/year)',
        projectDeadline: 'Project deadline',
      },
      packaging: {
        name: 'Emballage',
        heading: {
          general: 'Quel est votre emballage cible ?',
        },
        options: {
          pumpDispenser: 'Flacon pompe crème',
          sprayDispenser: 'Flacon foamer',
          jar: 'Pot',
          tube: 'Tube',
          aerosol: 'Aérosol',
          sachet: 'Sachet',
          bagInCan: 'Aérosol à poche',
          airPump: 'Pompe à air',
          bag: 'Sac',
          carton: 'Carton',
          bottle: 'Flacon pompe spray',
          compact: 'Compact',
          jarBottle: 'Bouteille-bocal',
          other: 'Autre',
        },
      },
      'modification-type': {
        name: 'Modification Type',
        heading: {
          general: 'Which parts of your formulation do you want to modify?',
          type: 'Modification type',
        },
        options: {
          base: 'Modify base formulation',
          colour: 'Modify colour',
          fragrance: 'Modify fragrance',
        },
      },
      'modification-issue': {
        name: 'Modification',
        heading: {
          general: 'What is the modification you want to make?',
        },
        explainIssue: 'Please explain your issue',
      },
      problem: {
        name: 'Problème',
        fix: {
          name: 'Défi',
        },
        enhance: { name: 'Amélioration' },
        heading: {
          fix: 'Quel est le défi auquel vous êtes confrontés avec votre formulation ?',
          enhance:
            'Quelle amélioration souhaitez-vous apporter à votre formulation ?',
        },
      },
      ingredients: {
        name: 'Ingrédients',
        heading: {
          general:
            'Quels ingrédients utilisez-vous actuellement dans la formulation ?',
        },
        azelisRawMaterials: 'Azelis matières premières',
        rawMaterials: 'Matières premières',
        rawMaterial: 'Matière première',
        rawMaterialFiles: 'Fichiers des matières premières',
        ingredientsFiles: 'Fichiers des ingrédients',
        upload:
          'Téléchargez votre formulation ici, ou ajoutez les matières premières ci-dessous.',
        other: 'Matières premières (p. ex. eau, silice, caprylyl glycol, ...)',
      },
      'active-ingredients': {
        name: 'Active ingredients',
        heading: {
          general: 'What is the active ingredient of the formulation?',
        },
        chooseActiveIngredient: 'Choose active ingredient',
        concentration: 'Concentration [g/L]',
        addAnother: 'Add another active ingredient',
      },
      'active-function': {
        name: 'Active function',
        heading: {
          general:
            'Do you want to add further ingredients to your formulation?',
          review: 'Function',
        },
        adjuvant: {
          name: 'Adjuvant',
          choose: 'Choose adjuvant',
        },
        stabilizer: {
          name: 'Stabilizer',
          choose: 'Choose stabilizer',
        },
        emulsifier: {
          name: 'Emulsifier',
          choose: 'Choose emulsifier',
        },
        liquidColorant: {
          name: 'Liquid colorant',
          choose: 'Choose liquid colorant',
        },
        solvent: {
          name: 'Solvent',
          choose: 'Choose solvent',
        },
      },
      formulations: {
        name: 'Formulations',
      },
      review: {
        name: 'Vérifier',
      },
    },
    modals: {
      cancelBriefing: {
        prompt: 'Souhaitez-vous annuler le briefing ?',
        content: 'Toutes les données saisies seront perdues.',
        confirm: 'Oui',
        cancel: 'Non',
      },
      customerSelection: {
        prompt: 'Spécifier l’utilisateur',
        content:
          'Veuillez choisir le client et le client utilisateur pour lesquels vous effectuez votre formulation',
        form: {
          customer: 'Client',
          customerUser: 'Client utilisateur',
        },
        confirm: 'Confirmer',
        cancel: 'Annuler',
        footer:
          'Si vous voulez quitter l’e-Lab d’Azelis, vous pouvez vous <link1 label="déconnecter ici" /> ou visiter le <link2 label="portail client d’Azelis" />',
        error: {
          heading: 'Un problème est survenu',
          messages: {
            loadingCustomer: 'Le chargement des données du client a échoué.',
            loadingCustomerUser:
              'Le chargement des données de l’utilisateur a échoué.',
            settingCustomerUser:
              'Il y a eu un problème lors du chargement du profil de l’utilisateur.',
          },
          content:
            'Veuillez réessayer. Si le problème persiste, veuillez vous déconnecter et reconnecter, ou <link1 label="contacter le support Azelis" />.',
          confirm: 'Essayer à nouveau',
          cancel: 'Déconnecter et réessayer',
          cannotSelectEmployeeUsers:
            "Il n'est pas possible de choisir employés utilisateurs",
        },
      },
      changeCustomerSelection: {
        change: 'Changer',
        prompt: 'Voulez-vous changer l’utilisateur que vous représentez ?',
        confirm: 'Oui, changer',
        cancel: 'Continuer',
      },
      deleteUploadedFile: {
        prompt: 'Voulez-vous supprimer le fichier ?',
        confirm: 'Oui, supprimer',
        cancel: 'Annuler',
      },
    },
    components: {
      briefingSelection: {
        heading: 'Comment voulez-vous commencer ?',
        buttons: {
          create: {
            title: 'Créer',
            copy: 'une nouvelle formulation',
          },
          enhance: {
            title: 'Améliorer',
            copy: 'une formulation existante',
          },
          modify: {
            title: 'Modify',
            copy: 'an existing formulation',
          },
          fix: {
            title: 'Corriger',
            copy: 'une formulation existante',
          },
        },
        inspirationLink: 'S’inspirer des formulations existantes',
        loading:
          'Veuillez patienter pendant que nous chargeons les informations nécessaires',
      },
      stepPackaging: {
        packagingSamplePrompt:
          'Si vous avez votre emballage à disposition, veuillez nous l’envoyer afin que nous puissions optimiser la formulation selon vos besoins. Veuillez inclure votre nom et le nom du projet afin que nous puissions le faire correspondre à votre brief.',
        addressLabel: 'Adresse',
        otherPackaging: 'Spécifier autre emballage',
      },
      review: {
        heading: 'Vérifier',
        productName: 'Le nom de mon projet',
      },
      success: {
        heading: 'Merci ! \n Demande envoyée avec succès.',
        emailInfo: 'Un résumé a été envoyé à votre adresse e-mail.',
        whatsNext: {
          heading: 'Quelle est la prochaine étape ?',
          review: 'Votre briefing sera examiné par notre expert.',
          contact: 'Votre gestionnaire de compte vous contactera bientôt.',
        },
        recommendations: {
          heading: 'Besoin d’inspiration ?',
          subheading:
            'Voici quelques autres formulations et ingrédients correspondant à votre application :',
          noDescription: 'Aucune description',
        },
      },
      projectOverview: {
        heading: 'Aperçu des formulations',
        emptyFormulations:
          'Il semble que vous n’ayez pas encore de formulations.',
        createFormulation: 'Créer une formulation',
        myFormulations: 'Mes formulations',
        teamFormulations: 'Formulations de {{team}}',
        team: 'équipe',
        filter: {
          country: 'Filtrer par pays',
          market: 'Filtrer par marché',
          application: 'Filtrer par application',
        },
        resetAllFilters: 'Effacer tous les filtres',
      },
      projectDetails: {
        projectType: {
          heading: 'Type de projet',
          create: 'Créer une nouvelle formulation',
          enhance: 'Améliorer une formulation existante',
          fix: 'Corriger une formulation existante',
        },
        referenceId: 'Identifiant de référence',
        formulationSpecifics: 'Spécificités de la formulation',
        fileDownloadHelp:
          'Si le fichier s’ouvre dans un nouvel onglet, utilisez ctrl + s (sous Windows) ou cmd + s (sur Mac) pour enregistrer le fichier',
      },
      account: {
        heading: 'Votre compte',
        name: 'Nom',
        email: 'Adresse e-mail',
        selectedMarket: 'Marché sélectionné',
      },
      fileUpload: {
        fileListLabel: 'Fichiers joints',
        privacy:
          'Vos téléchargements de données sont totalement sécurisés et ne seront pas partagés avec des tiers. Ils ne seront utilisés par Azelis que dans le contexte du projet pour garantir les meilleurs résultats pour vous.',
      },
      customerSelectionBar: {
        onBehalf: 'Vous formulez au nom de :',
      },
      intro: {
        heading: {
          main: 'Accès facile à toute notre expertise technique avec le nouveau e-Lab d’Azelis.',
          about: 'À propos de l’e-Lab',
        },
        content: {
          main: 'Le e-Lab d’Azelis vous permettra avec l’aide de nos experts de créer ou d’améliorer de nouvelles formulations.',
          benefits: [
            'Améliorer une formulation existante',
            'Créer de nouvelles formulations innovantes',
            'Contactez directement les experts Azelis du service technique',
            'Accessible 24h/24, 7j/7',
            'Commencez dès maintenant !',
          ],
        },
      },
      signIn: {
        passwordLabel: 'Mot de passe',
        email: 'Adresse e-mail',
        signUp: 'Vous n’avez pas de compte ? $t(labels:requestAccess)!',
        loginWithCustomerPortal: 'Connexion avec le portail client',
        pleaseWait: 'Veuillez patienter pendant que nous vous connectons.',
        errors: {
          errorEmpty: 'Veuillez saisir un e-mail et un mot de passe',
          errorIncorrect:
            'La combinaison de l’e-mail et du mot de passe saisis est incorrecte.',
          errorServerside:
            'Une erreur s’est produite, veuillez réessayer plus tard...',
          errorCustomerPortalLogin:
            'Nous n’avons pas pu accéder à votre profil sur le portail client.',
          access_denied:
            'Il semblerait que l’autorisation ait été refusée. Veuillez réessayer.',
        },
      },
      footer: {
        partOfAzelis: 'Rejoindre le portail client Azelis',
        copyright: 'Copyright © Azelis {{year}}. Tous droits réservés.',
        links: {
          cookie: 'Déclaration sur les cookies',
          privacy: 'Déclaration de confidentialité',
          terms: 'Conditions d’utilisation',
        },
      },
      countryMarketSelector: {
        reason: {
          empty: {
            heading: 'Aucun pays ou marché sélectionné',
            body: "Vous n'avez pas encore selectionné de pays ou de marché. Veuillez en sélectionner un parmi les options disponibles ci-dessous:",
            universalCustomer: {
              heading: 'Aucun entreprise, pays ou marché sélectionné',
              body: 'Vous n’avez pas encore sélectionné l’entreprise, pays ou marché. Veuillez en sélectionner un parmi les options disponibles ci-dessous:',
            },
          },
          invalid: {
            heading: 'Pays ou marché selectionné invalide',
            body: "Le pays ou le marché selectionné n'est pas valide. Veuillez en sélectionner un parmi les options disponibles ci-dessous:",
            universalCustomer: {
              heading: 'Sélection invalide',
              body: 'L’entreprise, le pay ou le marché sélectionné n’est pas valide. Veuillez en sélectionner un parmi les options disponibles ci-dessous:',
            },
          },
          preferences: {
            heading: 'Paramètres préférés',
            body: 'Veuillez garder à l’esprit que la modification de vos paramètres préférés ait un impact sur le contenu qui vous sera proposé.',
          },
        },
        customer: 'Entreprise',
        country: 'Pays',
        market: 'Marché',
        preferredLanguage: 'Langue préférée',
        confirm: 'Modifier',
        cancel: 'Annuler',
      },
      error404: {
        heading: 'Page non trouvée',
        body: "Nous n'avons rien trouvé à cette URL. Essayez de naviguer a l'aide du menu ou de verifier votre lien.",
      },
      noCountryMarketAvailable: {
        heading: 'Aucun pays ou marché valide trouvé',
        body: 'Votre profil utilisateur ne semble être associer a aucun pays/segment de marché pris en charge par le e-Lab. Veuillez contacter votre administarteur de système.',
      },
      filters: {
        filter: 'Filtre',
      },
    },
    emails: {
      customer: {
        subject: 'Briefing sur la formulation e-Lab d’Azelis reçu',
        html: {
          introNotCreatedByEmployee:
            'Merci ! Votre briefing pour {{branch}} {{branchFormulationPrefix}} a été envoyé avec succès aux experts Azelis du service technique.',
          introCreatedByEmployee:
            '{{employeeCreatorName}} a créé un briefing en votre nom pour {{branch}} {{branchFormulationPrefix}}. Il a été envoyé avec succès aux experts Azelis du service technique.',
          newFormulationPrefix: 'une nouvelle formulation',
          existingFormulationPrefix: 'une formulation existante',
          heading: 'Un nouveau briefing a été créé sur l’e-Lab',
          line1: 'Cher/Chère {{customerName}},',
          line2:
            'Notre équipe d’experts va maintenant examiner votre briefing et vous contactera bientôt.',
          line3:
            'Ci-dessous, veuillez trouver un résumé des informations qui nous ont été fournies.',
          referenceId: 'Identifiant de référence',
          projectName: 'Nom du projet',
          marketSegment: 'Segment de marché',
          country: 'Pays',
          thankYou: 'Merci d’avoir utilisé l’e-Lab d’Azelis.',
          inspirationLinkText: 'Inspiration',
          inspirationSuggestion:
            'Si vous ne voulez pas manquer les dernières tendances de votre secteur et les nouvelles informations sur le marché de nos experts Azelis, n’oubliez pas de consulter notre rubrique {{- inspirationLink}}.',
          theAzelisTeam: 'L’équipe Azelis',
          copyright: 'Copyright © Azelis {{year}}. Tous droits réservés.',
        },
      },
      lab: {
        subject: 'Briefing sur la formulation e-Lab par {{byDisplayName}}',
        byFor: '{{byMe}} pour {{forMe}}',
        html: {
          line1:
            'Un nouveau briefing pour {{branch}} {{branchFormulationPrefix}} a été publié par {{byDisplayName}} sur l’e-Lab d’Azelis.',
          referenceId: 'Identifiant de référence :',
          createdAt: 'Créé à :',
          projectName: 'Nom du projet :',
          pleaseContact:
            'Veuillez contacter {{- mailToLink}} pour discuter plus en détail.',
          unnamedProject: 'Projet sans nom',
          yourAzelisTeam: 'Votre équipe e-Lab Azelis',
        },
      },
      auxiliary: {
        branch: {
          create: 'créer',
          enhance: 'améliorer',
          modify: 'modify',
          fix: 'corriger',
        },
      },
    },
  },
};
